import { render } from "./CannyWidget.vue?vue&type=template&id=4df539d9"
import script from "./CannyWidget.vue?vue&type=script&lang=js"
export * from "./CannyWidget.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__